import React, { useEffect, useContext } from "react";
import { observer } from "mobx-react-lite";

import {
  Form,
  Button,
  ListGroup,
  Row,
  Col,
  FormControl,
} from "react-bootstrap";

import StoryContext from "../store/context";

const sorted = (A, B) => (A.region.name < B.region.name ? -1 : 1);

const User = observer(() => {
  const store = useContext(StoryContext);
  useEffect(() => store.getUsers(), []);
  return (
    <Row>
      <Col>
        <ListGroup.Item key={1000}>
          <Button
            variant="outline-primary"
            style={{ width: "100%" }}
            onClick={() =>
              store.setCurrent({
                uuid: null,
                username: "",
                password: "",
                admin: false,
              })
            }
          >
            Додати
          </Button>
        </ListGroup.Item>
        <ListGroup style={{ padding: 0, margin: 0 }}>
          {store.users.map((item, index) => (
            <ListGroup.Item key={index}>
              <Button
                variant="outline-primary"
                style={{ width: "100%" }}
                onClick={() => store.setCurrent(item)}
              >
                {item.username}
              </Button>
            </ListGroup.Item>
          ))}
        </ListGroup>
      </Col>
      <Col>
        <Form>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>Користувач</Form.Label>
            <Form.Control
              placeholder="Введите користувача"
              value={store.currentUserName}
              onChange={(Event) => store.setCurrentUserName(Event.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="formBasicPassword">
            <Form.Label>Пароль</Form.Label>
            <Form.Control
              type="password"
              placeholder="Пароль"
              value={store.currentPassword}
              onChange={(Event) => store.setCurrentPassword(Event.target.value)}
            />
          </Form.Group>
          <Form.Select
            value={store.currentAdmin}
            aria-label="Роль"
            fullWidth
            onChange={(event) => store.setCurrentAdmin(event.target.value)}
          >
            <option value={"merchandiser"}>Мерчендайзер</option>
            <option value={"supervisor"}>Супервайзер</option>
            <option value={"admin"}>Админ</option>
            <option value={"distributor"}>Дистрибьютор</option>
          </Form.Select>
          <Form.Check
            type="switch"
            id={`custom-switch-mode`}
            label="Режим"
            checked={store.currentMode}
            onChange={() => store.setCurrentMode()}
          />
          <ListGroup style={{ padding: 0, margin: 0 }}>
            {store.currentMode
              ? store.teamsUser.map((item, index) => (
                  <ListGroup.Item key={index}>
                    <Form.Check
                      type="switch"
                      id={`custom-switch-1-${index}`}
                      label={item.team.name}
                      checked={item.checked}
                      onChange={() => item.setChecked()}
                    />
                  </ListGroup.Item>
                ))
              : store.subteamsUser.map((item, index) => (
                  <ListGroup.Item key={index}>
                    <Form.Check
                      type="switch"
                      id={`custom-switch-2-${index}`}
                      label={item.subteam.name}
                      checked={item.checked}
                      onChange={() => item.setChecked()}
                    />
                  </ListGroup.Item>
                ))}
          </ListGroup>
          <h4>Области</h4>
          <ListGroup style={{ padding: 0, margin: 0 }}>
            {store.regionUser
              .slice()
              .sort(sorted)
              .map((item, index) => (
                <ListGroup.Item key={index}>
                  <Form.Check
                    type="switch"
                    id={`custom-switch-3-${index}`}
                    label={item.region.name}
                    checked={item.checked}
                    onChange={() => item.setChecked()}
                  />
                </ListGroup.Item>
              ))}
          </ListGroup>

          <Button variant="primary" onClick={() => store.setUser()}>
            Зберегти
          </Button>
        </Form>
      </Col>
    </Row>
  );
});

export default User;
